import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';
import { Commissioner } from '@lib/api/models/commissioner';
import { GoogleMap, MapAdvancedMarker } from '@angular/google-maps';
import { AccordionItemComponent } from '@shared/layout/accordion-item/accordion-item.component';

@Component({
    selector: 'app-commissioner-contact-address',
    imports: [
        ComponentsModule,
        GoogleMap,
        MapAdvancedMarker,
        AccordionItemComponent
    ],
    templateUrl: './commissioner-contact-address.component.html',
    standalone: true,
    styleUrl: './commissioner-contact-address.component.scss'
})
export class CommissionerContactAddressComponent {
    @Input() commissionerData: Commissioner | undefined;
    @Output() editContactAddressDetailsEvent: EventEmitter<void> = new EventEmitter<void>();

    protected options: google.maps.MapOptions = {
        zoom: 15,
        mapId: 'carebrokerage-map'
    };

    private map: google.maps.Map | undefined;

    editContactAddressDetails() {
        window.scrollTo(0, 0);
        this.editContactAddressDetailsEvent.emit();
    }

    initMap($event: google.maps.Map, commissionerData: Commissioner) {
        this.map = $event;
        if (commissionerData.address.lat && commissionerData.address.lng) {
            this.map.setOptions({
                center: { lat: +commissionerData.address.lat, lng: +commissionerData.address.lng }
            });
        }
    }
}
